define("settings/components/downgrade-setup", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/array", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/fetch", "later/utils/object-promise-proxy", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _array, _object, _service, _component2, _tracking, _emberConcurrency, _fetch, _objectPromiseProxy, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/array",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/fetch",0,"later/utils/object-promise-proxy",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div data-test-id="setup-wrapper" data-test-removed-sets-count={{this.socialSetsToRemove.length}}>
    <Shared::Wizard @closable={{false}} as |wizard|>
      <wizard.slide @portrait={{true}} as |slide|>
        <slide.body>
          <DowngradeSlideTable
            @account={{this.account}}
            @currentSubscriptionPlan={{this.subscriptionPlan}}
            @hasRecentlyExpiredPlan={{this.hasRecentlyExpiredPlan}}
            @recentlyExpiredPlan={{@recentlyExpiredPlan}}
          />
        </slide.body>
        <slide.footer>
          <div class="u--row u--row--noCollapse">
            <div class="u--col__6">
              <LinkToExternal @route="plans" class="o--btn o--btn--outline">
                {{t "account.downgrade.go_to_plans"}}
              </LinkToExternal>
            </div>
            <div class="u--col__6">
              <slide.nextButton @text={{t "shared_words.continue"}} />
            </div>
          </div>
        </slide.footer>
      </wizard.slide>
      {{#if @initialHasOverageGroups}}
        <wizard.slide @portrait={{true}} as |slide|>
          <slide.body>
            <DowngradeSlideGroups
              @account={{this.account}}
              @firstGroup={{this.firstGroup}}
              @groupCount={{this.sortedGroups.length}}
              @hasMergedGroups={{this.hasMergedGroups}}
              @mergeAllGroups={{this.mergeAllGroups}}
              @otherGroups={{this.otherGroups}}
              @unloadDeletedGroups={{this.unloadDeletedGroups}}
            />
          </slide.body>
          <slide.footer>
            <div class="u--row u--row--noCollapse">
              <div class="u--col__6">
                <LinkToExternal @route="plans" class="o--btn o--btn--outline">
                  {{t "account.downgrade.go_to_plans"}}
                </LinkToExternal>
              </div>
              <div class="u--col__6">
                <slide.nextButton
                  @isDisabled={{if this.hasMergedGroups false true}}
                  @text={{t "shared_words.continue"}}
                />
              </div>
            </div>
          </slide.footer>
        </wizard.slide>
      {{/if}}
      {{#if @initialHasOverageLinkinBioPages}}
        <wizard.slide @portrait={{true}} as |slide|>
          <slide.body>
            <DowngradeSlideLinkinbioPages
              @deleteLinkinbioPage={{this.deleteLinkinbioPage}}
              @linkinbioPages={{this.linkinbioPages}}
              @totalLinkinbioPages={{@totalSocialSets}}
            />
          </slide.body>
          <slide.footer>
            <div class="u--row u--row--noCollapse">
              <div class="u--col__6">
                <LinkToExternal @route="plans" class="o--btn o--btn--outline">
                  {{t "account.downgrade.go_to_plans"}}
                </LinkToExternal>
              </div>
              <div class="u--col__6">
                <slide.nextButton
                  @isDisabled={{or this.deleteLinkinbioPage.isRunning (gt this.linkinbioPages.length @totalSocialSets)}}
                  @onClick={{fn @updateInitialHasOverageLinkinbioPages this.linkinbioPages}}
                  @text={{t "shared_words.continue"}}
                />
              </div>
            </div>
          </slide.footer>
        </wizard.slide>
      {{/if}}
      {{#if @initialHasOverageSocialSets}}
        <wizard.slide @portrait={{true}} as |slide|>
          <slide.body>
            <DowngradeSlideSocialSets
              @organizeSocialProfiles={{@organizeSocialProfiles}}
              @overageSocialSets={{this.overageSocialSets}}
              @removeSocialSet={{this.removeSocialSet}}
              @restoreSocialSet={{this.restoreSocialSet}}
              @socialSets={{@socialSets}}
              @socialSetsToRemove={{this.socialSetsToRemove}}
              @targetSocialSetCount={{this.upcomingSocialSets}}
            />
          </slide.body>
          <slide.footer>
            <div class="u--row u--row--noCollapse">
              <div class="u--col__6">
                <LinkToExternal @route="plans" class="o--btn o--btn--outline">
                  {{t "account.downgrade.go_to_plans"}}
                </LinkToExternal>
              </div>
              <div class="u--col__6">
                <slide.nextButton
                  @isDisabled={{or
                    this.deleteSocialSets.isRunning
                    (lt this.socialSetsToRemove.length this.overageSocialSets)
                  }}
                  @onClick={{perform this.deleteSocialSets}}
                  @text={{t "shared_words.continue"}}
                />
              </div>
            </div>
          </slide.footer>
        </wizard.slide>
      {{/if}}
      {{#if @initialHasOverageUsers}}
        <wizard.slide @portrait={{true}} as |slide|>
          <slide.body>
            <DowngradeSlideUsers
              @deleteTeamMembers={{task this.deleteTeamMembers}}
              @overageUsers={{this.overageUsers}}
              @removeTeamMember={{this.removeTeamMember}}
              @restoreTeamMember={{this.restoreTeamMember}}
              @targetTeamMemberCount={{this.upcomingUsers}}
              @teamMembers={{this.teamMembers}}
              @teamMembersToRemove={{this.teamMembersToRemove}}
            />
          </slide.body>
          <slide.footer>
            <div class="u--row u--row--noCollapse">
              <div class="u--col__6">
                <LinkToExternal @route="plans" class="o--btn o--btn--outline">
                  {{t "account.downgrade.go_to_plans"}}
                </LinkToExternal>
              </div>
              <div class="u--col__6">
                <slide.nextButton
                  @isDisabled={{or
                    this.deleteTeamMembers.isRunning
                    (lt this.teamMembersToRemove.length this.overageUsers)
                  }}
                  @onClick={{perform this.deleteTeamMembers}}
                  @text={{t "account.downgrade.team_members.button"}}
                />
              </div>
            </div>
          </slide.footer>
        </wizard.slide>
      {{/if}}
      <wizard.slide @portrait={{true}} as |slide|>
        <slide.body>
          <DowngradeSlideComplete />
        </slide.body>
      </wizard.slide>
    </Shared::Wizard>
  </div>
  */
  {
    "id": "dOgJD/xO",
    "block": "[[[10,0],[14,\"data-test-id\",\"setup-wrapper\"],[15,\"data-test-removed-sets-count\",[30,0,[\"socialSetsToRemove\",\"length\"]]],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@closable\"],[false]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"slide\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,2,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,1],null,[[\"@account\",\"@currentSubscriptionPlan\",\"@hasRecentlyExpiredPlan\",\"@recentlyExpiredPlan\"],[[30,0,[\"account\"]],[30,0,[\"subscriptionPlan\"]],[30,0,[\"hasRecentlyExpiredPlan\"]],[30,3]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,2,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n            \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline\"]],[[\"@route\"],[\"plans\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,3],[\"account.downgrade.go_to_plans\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n            \"],[8,[30,2,[\"nextButton\"]],null,[[\"@text\"],[[28,[37,3],[\"shared_words.continue\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n\"],[41,[30,4],[[[1,\"      \"],[8,[30,1,[\"slide\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,5,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,5],null,[[\"@account\",\"@firstGroup\",\"@groupCount\",\"@hasMergedGroups\",\"@mergeAllGroups\",\"@otherGroups\",\"@unloadDeletedGroups\"],[[30,0,[\"account\"]],[30,0,[\"firstGroup\"]],[30,0,[\"sortedGroups\",\"length\"]],[30,0,[\"hasMergedGroups\"]],[30,0,[\"mergeAllGroups\"]],[30,0,[\"otherGroups\"]],[30,0,[\"unloadDeletedGroups\"]]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,5,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline\"]],[[\"@route\"],[\"plans\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,3],[\"account.downgrade.go_to_plans\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[30,5,[\"nextButton\"]],null,[[\"@isDisabled\",\"@text\"],[[52,[30,0,[\"hasMergedGroups\"]],false,true],[28,[37,3],[\"shared_words.continue\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[5]]]]],[1,\"\\n\"]],[]],null],[41,[30,6],[[[1,\"      \"],[8,[30,1,[\"slide\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,7,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,6],null,[[\"@deleteLinkinbioPage\",\"@linkinbioPages\",\"@totalLinkinbioPages\"],[[30,0,[\"deleteLinkinbioPage\"]],[30,0,[\"linkinbioPages\"]],[30,8]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,7,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline\"]],[[\"@route\"],[\"plans\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,3],[\"account.downgrade.go_to_plans\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[30,7,[\"nextButton\"]],null,[[\"@isDisabled\",\"@onClick\",\"@text\"],[[28,[37,7],[[30,0,[\"deleteLinkinbioPage\",\"isRunning\"]],[28,[37,8],[[30,0,[\"linkinbioPages\",\"length\"]],[30,8]],null]],null],[28,[37,9],[[30,9],[30,0,[\"linkinbioPages\"]]],null],[28,[37,3],[\"shared_words.continue\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[7]]]]],[1,\"\\n\"]],[]],null],[41,[30,10],[[[1,\"      \"],[8,[30,1,[\"slide\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,11,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,10],null,[[\"@organizeSocialProfiles\",\"@overageSocialSets\",\"@removeSocialSet\",\"@restoreSocialSet\",\"@socialSets\",\"@socialSetsToRemove\",\"@targetSocialSetCount\"],[[30,12],[30,0,[\"overageSocialSets\"]],[30,0,[\"removeSocialSet\"]],[30,0,[\"restoreSocialSet\"]],[30,13],[30,0,[\"socialSetsToRemove\"]],[30,0,[\"upcomingSocialSets\"]]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,11,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline\"]],[[\"@route\"],[\"plans\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,3],[\"account.downgrade.go_to_plans\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[30,11,[\"nextButton\"]],null,[[\"@isDisabled\",\"@onClick\",\"@text\"],[[28,[37,7],[[30,0,[\"deleteSocialSets\",\"isRunning\"]],[28,[37,11],[[30,0,[\"socialSetsToRemove\",\"length\"]],[30,0,[\"overageSocialSets\"]]],null]],null],[28,[37,12],[[30,0,[\"deleteSocialSets\"]]],null],[28,[37,3],[\"shared_words.continue\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[11]]]]],[1,\"\\n\"]],[]],null],[41,[30,14],[[[1,\"      \"],[8,[30,1,[\"slide\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,15,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,13],null,[[\"@deleteTeamMembers\",\"@overageUsers\",\"@removeTeamMember\",\"@restoreTeamMember\",\"@targetTeamMemberCount\",\"@teamMembers\",\"@teamMembersToRemove\"],[[28,[37,14],[[30,0,[\"deleteTeamMembers\"]]],null],[30,0,[\"overageUsers\"]],[30,0,[\"removeTeamMember\"]],[30,0,[\"restoreTeamMember\"]],[30,0,[\"upcomingUsers\"]],[30,0,[\"teamMembers\"]],[30,0,[\"teamMembersToRemove\"]]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,15,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline\"]],[[\"@route\"],[\"plans\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,3],[\"account.downgrade.go_to_plans\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[30,15,[\"nextButton\"]],null,[[\"@isDisabled\",\"@onClick\",\"@text\"],[[28,[37,7],[[30,0,[\"deleteTeamMembers\",\"isRunning\"]],[28,[37,11],[[30,0,[\"teamMembersToRemove\",\"length\"]],[30,0,[\"overageUsers\"]]],null]],null],[28,[37,12],[[30,0,[\"deleteTeamMembers\"]]],null],[28,[37,3],[\"account.downgrade.team_members.button\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[15]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[8,[30,1,[\"slide\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,16,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,15],null,null,null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[16]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"],[13]],[\"wizard\",\"slide\",\"@recentlyExpiredPlan\",\"@initialHasOverageGroups\",\"slide\",\"@initialHasOverageLinkinBioPages\",\"slide\",\"@totalSocialSets\",\"@updateInitialHasOverageLinkinbioPages\",\"@initialHasOverageSocialSets\",\"slide\",\"@organizeSocialProfiles\",\"@socialSets\",\"@initialHasOverageUsers\",\"slide\",\"slide\"],false,[\"shared/wizard\",\"downgrade-slide-table\",\"link-to-external\",\"t\",\"if\",\"downgrade-slide-groups\",\"downgrade-slide-linkinbio-pages\",\"or\",\"gt\",\"fn\",\"downgrade-slide-social-sets\",\"lt\",\"perform\",\"downgrade-slide-users\",\"task\",\"downgrade-slide-complete\"]]",
    "moduleName": "settings/components/downgrade-setup.hbs",
    "isStrictMode": false
  });
  let DowngradeSetupComponent = _exports.default = (_class = class DowngradeSetupComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor4, this);
      _initializerDefineProperty(this, "slideIndex", _descriptor5, this);
      _initializerDefineProperty(this, "hasMergedGroups", _descriptor6, this);
      _initializerDefineProperty(this, "socialSetsToRemove", _descriptor7, this);
      _initializerDefineProperty(this, "teamMembersToRemove", _descriptor8, this);
      _defineProperty(this, "deleteLinkinbioPage", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (linkinbioPage) {
          try {
            const page = yield (0, _objectPromiseProxy.default)(linkinbioPage);
            yield page.destroyRecord();
          } catch (error) {
            this.alerts.warning(error);
          } finally {
            try {
              yield this.account.reload();
            } catch (error) {
              // Do Nothing
            }
          }
        }
      }), {
        drop: true
      }, "deleteLinkinbioPage", null));
      _defineProperty(this, "deleteSocialSets", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            for (const set of this.socialSetsToRemove) {
              yield set.destroyRecord();
            }
          } catch (error) {
            this.alerts.warning(error);
          } finally {
            try {
              yield this.account.reload();
            } catch (error) {
              // Do Nothing
            }
            this.socialSetsToRemove.clear();
          }
        }
      }), {
        drop: true
      }, "deleteSocialSets", null));
      _defineProperty(this, "deleteTeamMembers", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            for (const teamMember of this.teamMembersToRemove) {
              yield teamMember.destroyRecord();
            }
          } catch (error) {
            this.alerts.warning(error);
          } finally {
            try {
              yield this.account.reload();
            } catch (error) {
              // Do Nothing
            }
            this.teamMembersToRemove.clear();
          }
        }
      }), {
        drop: true
      }, "deleteTeamMembers", null));
    }
    get account() {
      return this.auth.currentAccount;
    }
    get accountGroups() {
      return this.account.groups;
    }
    get sortedGroups() {
      return !this.accountGroups.isDestroyed ? this.accountGroups.sortBy('createdTime') : [];
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get firstGroup() {
      return this.sortedGroups.firstObject;
    }
    get hasOverageLinkinbioPages() {
      return this.account.hasOverageLinkinbioPages;
    }
    get hasRecentlyExpiredPlan() {
      return this.args.recentlyExpiredPlan && this.args.recentlyExpiredPlan.id !== this.subscriptionPlan.id;
    }
    get lastGroup() {
      return this.auth.lastGroup;
    }
    get linkinbioPages() {
      return this.account.linkinbioPages.filter(page => Boolean(page?.get('id')));
    }
    get overageSocialSets() {
      return this.account?.setsOverages;
    }
    get overageUsers() {
      return this.upcomingOverages?.users;
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }
    get teamMembers() {
      return this.account.users.filterBy('isAccountOwner', false);
    }
    get otherGroups() {
      return !this.sortedGroups.isDestroyed ? this.sortedGroups.slice(1) : [];
    }
    get upcomingOverages() {
      return this.account.upcomingOverages;
    }
    get upcomingSocialSets() {
      const {
        cancelled,
        upcomingTotalSocialSets
      } = this.subscription;
      if (cancelled || !upcomingTotalSocialSets) {
        return this.subscriptionPlan.numberOfSocialSets;
      }
      return upcomingTotalSocialSets;
    }
    get upcomingUsers() {
      const {
        cancelled,
        upcomingTotalUsers
      } = this.subscription;
      if (cancelled || !upcomingTotalUsers) {
        return this.subscriptionPlan.numberOfUsers;
      }
      return upcomingTotalUsers;
    }
    mergeAllGroups(successFunction, failureFunction) {
      const endpoint = '/api/v2/merge_groups.json';
      const config = {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          account_id: this.account.id
        }
      };
      return (0, _fetch.fetch)(endpoint, config).then(response => {
        successFunction();
        this.alerts.success(this.intl.t('alerts.account.downgrade.groups.groups_merged'));
        this.firstGroup.reload();
        this.otherGroups.forEach(group => {
          group.set('socialProfiles', []);
          group.set('members', []);
          group.set('mediaItemCount', 0);
        });
        this.hasMergedGroups = true;
        return response;
      }).catch(error => {
        failureFunction();
        return error;
      });
    }
    removeSocialSet(set) {
      if (set) {
        this.socialSetsToRemove.addObject(set);
      }
    }
    restoreSocialSet(set) {
      this.socialSetsToRemove.removeObject(set);
    }
    removeTeamMember(user) {
      if (user) {
        this.teamMembersToRemove.addObject(user);
      }
    }
    restoreTeamMember(user) {
      this.teamMembersToRemove.removeObject(user);
    }
    unloadDeletedGroups() {
      this.otherGroups.forEach(group => {
        group.unloadRecord();
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "slideIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasMergedGroups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "socialSetsToRemove", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)([]);
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "teamMembersToRemove", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)([]);
    }
  }), _applyDecoratedDescriptor(_class.prototype, "mergeAllGroups", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "mergeAllGroups"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeSocialSet", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeSocialSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restoreSocialSet", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "restoreSocialSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeTeamMember", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeTeamMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restoreTeamMember", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "restoreTeamMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unloadDeletedGroups", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "unloadDeletedGroups"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DowngradeSetupComponent);
});